/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_OpenInputs */

const en_chat_open = /** @type {(inputs: Chat_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Open chat`)
};

const ar_chat_open = /** @type {(inputs: Chat_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`افتح المحادثة`)
};

const bn_chat_open = /** @type {(inputs: Chat_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`চ্যাট খুলুন`)
};

const de_chat_open = /** @type {(inputs: Chat_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chat öffnen`)
};

const es_chat_open = /** @type {(inputs: Chat_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir chat`)
};

const fr_chat_open = /** @type {(inputs: Chat_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ouvrir le chat`)
};

const pt_chat_open = /** @type {(inputs: Chat_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abrir bate-papo`)
};

const zh_chat_open = /** @type {(inputs: Chat_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`打开聊天`)
};

const tr_chat_open = /** @type {(inputs: Chat_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sohbeti aç`)
};

const ru_chat_open = /** @type {(inputs: Chat_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть чат`)
};

const pl_chat_open = /** @type {(inputs: Chat_OpenInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Otwórz czat`)
};

/**
* | output |
* | --- |
* | "Open chat" |
*
* @param {Chat_OpenInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const chat_open = /** @type {((inputs?: Chat_OpenInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_OpenInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_chat_open(inputs)
	if (locale === "bn") return bn_chat_open(inputs)
	if (locale === "de") return de_chat_open(inputs)
	if (locale === "es") return es_chat_open(inputs)
	if (locale === "fr") return fr_chat_open(inputs)
	if (locale === "pt") return pt_chat_open(inputs)
	if (locale === "zh") return zh_chat_open(inputs)
	if (locale === "tr") return tr_chat_open(inputs)
	if (locale === "ru") return ru_chat_open(inputs)
	if (locale === "pl") return pl_chat_open(inputs)
	return en_chat_open(inputs)
});